import React from "react"
import { Text } from "./styles"

const H1 = () => {
  return <Text>95 lat Polskiego Radia</Text>
}

export default H1
